import React, { createContext, useContext, useState } from "react";

const ScopeContext = createContext(null);

export function ScopeProvider({ children }) {
  const [scope, setScope] = useState("all"); // all | personal | professional
  return <ScopeContext.Provider value={{ scope, setScope }}>{children}</ScopeContext.Provider>;
}

export const useScope = () => useContext(ScopeContext);
